// Cloudinary image upload utility for Ringez blog editor
// Mirrors the Get Seen Branding implementation but uses Ringez-specific folders.

const CLOUDINARY_CONFIG = {
  cloudName: process.env.REACT_APP_CLOUDINARY_CLOUD_NAME,
  uploadPreset: process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET,
  blogImagesFolder: process.env.REACT_APP_CLOUDINARY_BLOG_IMAGES_FOLDER || 'ringez-blog-images',
  blogFeaturedFolder: process.env.REACT_APP_CLOUDINARY_BLOG_FEATURED_FOLDER || 'ringez-blog-featured-images'
};

/**
 * Upload image to Cloudinary for Ringez blogs
 * @param {File} file - Image file to upload
 * @param {string} folder - Cloudinary folder (default: 'ringez-blog-images')
 * @returns {Promise<string>} - Cloudinary image URL
 */
export const uploadImageToCloudinary = async (file, folder = CLOUDINARY_CONFIG.blogImagesFolder) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_preset', CLOUDINARY_CONFIG.uploadPreset);
  formData.append('folder', folder);

  if (!CLOUDINARY_CONFIG.cloudName || !CLOUDINARY_CONFIG.uploadPreset) {
    throw new Error('Cloudinary is not configured. Check frontend .env variables.');
  }

  const response = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUDINARY_CONFIG.cloudName}/image/upload`,
    {
      method: 'POST',
      body: formData
    }
  );

  const data = await response.json();

  if (data.secure_url) {
    return data.secure_url;
  }

  console.error('Cloudinary upload error:', data);
  throw new Error('Cloudinary upload failed');
};

/**
 * React Quill image handler for inline Cloudinary uploads
 * Uses the default Ringez blog images folder.
 */
export const imageHandler = function () {
  const input = document.createElement('input');
  input.setAttribute('type', 'file');
  input.setAttribute('accept', 'image/*');
  input.click();

  input.onchange = async () => {
    const file = input.files[0];
    if (!file) return;

    const quill = this.quill;
    const range = quill.getSelection(true);

    // Insert temporary loading placeholder
    quill.insertEmbed(range.index, 'image', '/images/loading.gif');
    quill.setSelection(range.index + 1);

    try {
      const imageUrl = await uploadImageToCloudinary(file, CLOUDINARY_CONFIG.blogImagesFolder);
      quill.deleteText(range.index, 1);
      quill.insertEmbed(range.index, 'image', imageUrl);
      quill.setSelection(range.index + 1);
    } catch (err) {
      alert('Image upload failed. Please try again.');
      quill.deleteText(range.index, 1);
    }
  };
};

export default { uploadImageToCloudinary, imageHandler };

